export default function Hero() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative w-full min-h-screen flex flex-col items-center justify-center text-center overflow-hidden"
    >
      {/* ── Background image with Ken Burns ── */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/98d25d349d372df635e17fa92f9278a8.jpg"
          alt="Piscina INSERCOM"
          className="w-full h-full object-cover object-top animate-ken-burns origin-center"
          style={{ willChange: 'transform' }}
        />

        {/* Dark teal gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-teal-900/60 via-teal-800/40 to-teal-900/70" />

        {/* ── Caustics / light ripple layer ── */}
        <div
          className="absolute inset-0 animate-caustics animate-pulse2"
          style={{
            backgroundImage:
              'radial-gradient(ellipse 80px 40px at 20% 30%, rgba(255,255,255,0.18) 0%, transparent 70%),' +
              'radial-gradient(ellipse 60px 30px at 70% 60%, rgba(255,255,255,0.14) 0%, transparent 70%),' +
              'radial-gradient(ellipse 100px 50px at 50% 20%, rgba(255,255,255,0.10) 0%, transparent 70%),' +
              'radial-gradient(ellipse 50px 25px at 85% 40%, rgba(255,255,255,0.12) 0%, transparent 70%)',
            backgroundSize: '400% 400%',
            mixBlendMode: 'screen',
          }}
        />

        {/* ── Light streak shimmer 1 ── */}
        <div
          className="absolute inset-0 animate-shimmer1 pointer-events-none"
          style={{
            background:
              'linear-gradient(105deg, transparent 35%, rgba(255,255,255,0.22) 50%, transparent 65%)',
          }}
        />

        {/* ── Light streak shimmer 2 ── */}
        <div
          className="absolute inset-0 animate-shimmer2 pointer-events-none"
          style={{
            background:
              'linear-gradient(110deg, transparent 38%, rgba(255,255,255,0.15) 52%, transparent 66%)',
          }}
        />

        {/* ── Animated wave bands at bottom ── */}
        <div className="absolute bottom-0 left-0 right-0 h-40 overflow-hidden pointer-events-none">
          {/* Wave 1 */}
          <div
            className="absolute bottom-0 animate-wave-x"
            style={{
              width: '200%',
              height: '80px',
              background:
                'radial-gradient(ellipse 25% 100% at 12.5% 100%, rgba(20,184,166,0.35) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 37.5% 100%, rgba(20,184,166,0.35) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 62.5% 100%, rgba(20,184,166,0.35) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 87.5% 100%, rgba(20,184,166,0.35) 0%, transparent 70%)',
              borderRadius: '50% 50% 0 0 / 30% 30% 0 0',
            }}
          />
          {/* Wave 2 */}
          <div
            className="absolute bottom-0 animate-wave-x-rev"
            style={{
              width: '200%',
              height: '60px',
              background:
                'radial-gradient(ellipse 25% 100% at 12.5% 100%, rgba(13,148,136,0.28) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 37.5% 100%, rgba(13,148,136,0.28) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 62.5% 100%, rgba(13,148,136,0.28) 0%, transparent 70%),' +
                'radial-gradient(ellipse 25% 100% at 87.5% 100%, rgba(13,148,136,0.28) 0%, transparent 70%)',
              borderRadius: '50% 50% 0 0 / 40% 40% 0 0',
            }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-6 px-6 w-full">
        <p className="text-teal-200 text-sm font-semibold tracking-[0.3em] uppercase">
          Empresa líder en República Dominicana
        </p>
        <h1 className="text-6xl md:text-8xl font-black text-white tracking-widest drop-shadow-lg">
          BIENVENIDOS
        </h1>
        <p className="text-white text-xl md:text-2xl font-medium tracking-widest italic drop-shadow">
          ¡HACEMOS REALIDAD TUS SUEÑOS!
        </p>
        <div className="w-16 h-0.5 bg-teal-300 my-2" />
        <p className="text-white/80 text-base max-w-lg">
          Diseño, construcción y mantenimiento de piscinas e hidromasajes con más de 15 años de experiencia.
        </p>
        <div className="flex gap-4 mt-4">
          <button
            onClick={() => handleScroll("#contacto")}
            className="bg-teal-500 hover:bg-teal-400 text-white font-bold px-8 py-3 rounded-full tracking-widest text-sm transition-all cursor-pointer whitespace-nowrap hover:scale-105"
          >
            COTIZAR
          </button>
          <button
            onClick={() => handleScroll("#servicios")}
            className="border-2 border-white text-white hover:bg-white hover:text-teal-800 font-bold px-8 py-3 rounded-full tracking-widest text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            SERVICIOS
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/60 text-lg" />
      </div>
    </section>
  );
}
